(function ($) {
    $(() => {

        $('.name-validation').keydown(e => {
            // Allow: backspace, delete, tab, escape, enter and .
            if (
                $.inArray(e.keyCode, [46, 8, 9, 27, 13, 110]) !== -1 ||
                // Allow: Ctrl+A, Command+A
                (e.keyCode === 65 && (e.ctrlKey === true || e.metaKey === true)) ||
                e.key === '+' ||
                // Allow: home, end, left, right, down, up
                (e.keyCode >= 35 && e.keyCode <= 40)
            ) {
                // let it happen, don't do anything
                return;
            }
            // Ensure that it is char [a-zA-Z] or space, ', é,í,ó,ö,ő,ú,ü,ű
            if (
                (e.keyCode < 64 || e.keyCode > 90) &&
                (e.keyCode !== 32 &&
                    e.key !== "'" &&
                    e.keyCode !== 222 &&
                    e.keyCode !== 186 &&
                    e.keyCode !== 226 &&
                    e.keyCode !== 187 &&
                    e.keyCode !== 192 &&
                    e.keyCode !== 219 &&
                    e.keyCode !== 221 &&
                    e.keyCode !== 191 &&
                    e.keyCode !== 220)
            ) {
                e.preventDefault();
            }
        });

        function namevalidation(inputtxt) {
            const regexp = /[a-zA-Z áéíóöőúüűÁÉÍÓÖŐÚÜŰ\.'\-]*/gm;
            if (inputtxt.match(regexp)) {
                return true;
            }
            return false;
        }

        function resetNewsletterForm() {
            $('.js-newsletter-form').trigger('reset');
            // grecaptcha.reset();
        }

        // front-form
        $('.js-newsletter-form').on('submit', function (e) {
            e.preventDefault();
            const $this = $(this);

            const name = $('#name').val();

            if (!namevalidation(name)) {
                Swal.fire({
                    title: ajax.translations.hibas_nev,
                    text: '',
                    button: ajax.translations.ok
                });
            } else if (
                $('#privacy_policy_footer').prop('checked') || $('#privacy_policy').prop('checked')
            ) {
                // $(this)
                //     .find('.newsletter-btn')
                //     .prop('disabled', true);
                const formdata = $this.serializeArray();
                //formdata[formdata.length] = { name: 'recaptcha', value: $(this).find('#g-recaptcha-response').val() };
                $.ajax({
                    url: ajax.ajaxurl,
                    type: 'POST',
                    data: {
                        action: 'newsletter_form',
                        datas: formdata
                    },
                    success(data) {
                        const result = JSON.parse(data);
                        Swal.fire({
                            title: result.title,
                            text: 'Sikeres hírlevélfeliratkozás!',
                            imageUrl: '/wp-content/themes/wp-dmlab/assets/img/eredmeny.svg',
                            imageHeight: 100,
                            imageAlt: 'Pipa',
                            button: 'ok'
                        });
                        if (result.status == 'success') {
                            resetNewsletterForm();
                        }
                    }
                }).done(response => {
                    $this.find('.newsletter-btn').prop('disabled', false);
                });
            } else {
                if (!$('.firstcheck').prop('checked')) {
                    $('.firstcheck_label').addClass('has-error-text');
                    Swal.fire({
                        title: ajax.news_chb_1,
                        text: '',
                        icon: 'error',
                        button: ajax.translations.ok
                    });
                }
                if (!$('.secondcheck').prop('checked')) {
                    $('.secondcheck_label').addClass('has-error-text');
                    Swal.fire({
                        title: ajax.news_chb_2,
                        text: '',
                        icon: 'error',
                        button: ajax.translations.ok
                    });
                }
            }
        });

        $('.firstcheck').change(() => {
            $('.firstcheck_label').removeClass('has-error-text');
        });

        $('.secondcheck').change(() => {
            $('.secondcheck_label').removeClass('has-error-text');
        });
    });
})(jQuery);